import SurveyForm from './SurveyForm';

export default SurveyForm;
